import { useCallback } from "react";
import { SERVER_HOST } from "../../constants/config";
import { getEkycHeaders } from "../../utils/ekycHeaders";

const BaseAPIUrl = SERVER_HOST;

const useMyPRService = () => {

  const extractNameAndIDNumber = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders(),
        method: "post",
        body: params,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mypr-verification/extract-name-and-id-number",
        config
      ).then((response) => response.json());
    },
    []
  );

  const uploadFront = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: getEkycHeaders(),
        body: params,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mypr-verification/upload-front",
        config
      ).then((response) => response.json());
    },
    []
  );

  const verifyFront = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mypr-verification/verify-front",
        config
      ).then((response) => response.json());
    },
    []
  );

  const uploadBack = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: getEkycHeaders(),
        body: params,
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mypr-verification/upload-back",
        config
      ).then((response) => response.json());
    },
    []
  );

  const verifyBack = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mypr-verification/verify-back",
        config
      ).then((response) => response.json());
    },
    []
  );

  const checkResult = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mypr-verification/check-result",
        config
      ).then((response) => response.json());
    },
    []
  );

  const getMyPRRejectReason = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/mypr-verification/reject-reason",
        config
      ).then((response) => response.json());
    },
    []
  );

  return {
    extractNameAndIDNumber,
    uploadFront,
    verifyFront,
    uploadBack,
    verifyBack,
    checkResult,
    getMyPRRejectReason,
  };
};

export { useMyPRService };
